import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useState } from 'react'
import { FiAlertCircle } from 'react-icons/fi'

import { ValidateEmail } from '../../../helpers'
import useHomepage from '../../../hooks/useHomepage'
import CloseArrow from '../../../images/close.svg'
import Invite from '../../../models/Invite'
import { ApiService } from '../../../services'
import InlineSpinner from '../../common/InlineSpinner'

type Props = {
  onClose: () => void
  settings: {
    utmContent: string
    fullAddress: string
  }
}

type State = {
  email: string
  emailValid: boolean
  companyNameValid: boolean
  companyName: string
  invite: Invite | null
  loading: boolean
}

const CateringDeliveryForm: React.FC<Props> = ({ onClose, settings }) => {
  const { t } = useTranslation()

  const [state, setState] = useState<State>({
    invite: null,
    email: '',
    emailValid: true,
    loading: false,
    companyName: '',
    companyNameValid: true,
  })
  const { showModal } = useHomepage()

  const onSubmitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (state.loading) return
    state.email = state.email.trim()
    const emailValid = ValidateEmail(state.email)
    const companyNameValid = !!state.companyName

    if (emailValid && companyNameValid) {
      setState({ ...state, emailValid, companyNameValid, loading: true })

      ApiService.createCateringLead({
        company_name: state.companyName,
        full_address: settings.fullAddress,
        email: state.email,
      }).finally(() => {
        onClose()
        showModal({ name: 'catering-delivery-confirmation' })
      })
    } else {
      setState({ ...state, emailValid, companyNameValid })
    }
  }

  const onEmailChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, email: e.target.value })
  }

  const onCompanyNameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, companyName: e.target.value })
  }

  return (
    <>
      <button className="modal__close" onClick={onClose}>
        <img src={CloseArrow} />
      </button>
      <div className="modal__title modal__title--small">
        {t('Please enter your email to see our delivery options near you')}
      </div>
      <div className="modal__content">
        <form className="form form--full" onSubmit={onSubmitHandler}>
          <input
            className={`form__input form__input--full form__input--email ${!state.emailValid && 'form__input--error'}`}
            type="text"
            name="email"
            value={state.email}
            placeholder={t('Your email address')}
            onChange={onEmailChangeHandler}
          />
          {!state.emailValid && (
            <div className="form__error-message">
              <FiAlertCircle /> {t('Invalid email address')}
            </div>
          )}
          <input
            className={`form__input form__input--full form__input--company-name ${
              !state.companyNameValid && 'form__input--error'
            }`}
            type="text"
            name="email"
            value={state.companyName}
            placeholder={t('Company Name')}
            onChange={onCompanyNameChangeHandler}
          />
          {!state.companyNameValid && (
            <div className="form__error-message">
              <FiAlertCircle /> {t('Comapny Name is required')}
            </div>
          )}
          <button className="form__action form__action--full red-cta" type="submit">
            {state.loading ? <InlineSpinner /> : 'Submit'}
          </button>
        </form>
      </div>
    </>
  )
}

export default CateringDeliveryForm
